import React, { useContext, useState, useEffect, useMemo } from "react";
import { Table, Button, Form, Pagination, Modal, Spinner, Col, Row } from "react-bootstrap";
import axios from "axios";
import * as CONST from "../../includes/Constant";
import Loading from 'react-fullscreen-loading';
import { AuthContext } from '../../context/AuthContext';
import Select from 'react-select';
import useAuthInfo from "../../../hooks/IsAdmin";
import { SD_GET_YEAR_DATA, SD_FY_MONTHS, S_CURRENT_FINACIAL_MONTH, S_FORMAT_CURRENCY_AND_AMOUNT } from "../../includes/staticData";
import { Accordion, Card } from "react-bootstrap";
export default function ManageExchange() {
  const { isAdmin, eDepartmentId, eUser_id } = useAuthInfo();
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(30);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  /* SEARCH VARIABLES */
  const [searchParams, setSearchParams] = useState({});
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const { YEAR_LIST, CURRENT_FINANCIAL_YEAR, CURRENT_YEAR, SELECTED_YEAR } = SD_GET_YEAR_DATA();
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);

  useEffect(() => {
    const defaultParams = {
      year: CURRENT_FINANCIAL_YEAR,
      /* month: S_CURRENT_FINACIAL_MONTH().value || "", */
      month: ""
    };
    setSearchParams(defaultParams);
    if (YEAR_LIST) setFinancialYears(YEAR_LIST);
    if (CURRENT_FINANCIAL_YEAR) setCurrentFinancialYears(CURRENT_FINANCIAL_YEAR);
    if (SELECTED_YEAR) setSelectedYear(SELECTED_YEAR);
    setSelectedMonth();
    setCurrentMonth(S_CURRENT_FINACIAL_MONTH());
    setSearchParams(defaultParams);
    //setOpenMonths({ [getCurrentMonthKey()]: true });
  }, []);
  // Runs when dependencies change
  useEffect(() => {
    if (Object.keys(searchParams).length > 0) {
      fetchData();
    }
  }, [currentPage, recordsPerPage, sortColumn, sortOrder, searchParams]);
  const fetchData = async (param) => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.GET_EXCHANGE_LIST, {
        params: {
          year: searchParams.year,
          month: searchParams?.month || "",
          page: currentPage,
          per_page: recordsPerPage,
          sort_by: sortColumn,
          sort_order: sortOrder,
        }
      });
      if (response.data) {
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      dataField: "sr",
      text: "Sr.no",
      sortable: true,
      onSort: () => handleSort("sr"),
    },
    {
      dataField: "fetched_date",
      text: "Date",
      sort: true,
      onSort: () => handleSort("fetched_date"),
      formatter: (cell) => {
        if (!cell) return "";
        const date = new Date(cell);
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
      }
    },
    {
      dataField: "USD",
      text: "USD",
      sortable: true,
      onSort: () => handleSort("USD"),
      formatter: (cell, row) => {
        const amount = S_FORMAT_CURRENCY_AND_AMOUNT("USD", row.USD)
        return (amount)
      }
    },
    {
      dataField: "GBP",
      text: "GBP",
      sortable: true,
      onSort: () => handleSort("GBP"),
      formatter: (cell, row) => {
        const amount = S_FORMAT_CURRENCY_AND_AMOUNT("GBP", row.GBP)
        return (amount)
      }
    },
    {
      dataField: "EUR",
      text: "EUR",
      sortable: true,
      onSort: () => handleSort("EUR"),
      formatter: (cell, row) => {
        const amount = S_FORMAT_CURRENCY_AND_AMOUNT("EUR", row.EUR)
        return (amount)
      }
    },
    {
      dataField: "SGD",
      text: "SGD",
      sortable: true,
      onSort: () => handleSort("SGD"),
      formatter: (cell, row) => {
        const amount = S_FORMAT_CURRENCY_AND_AMOUNT("SGD", row.SGD)
        return (amount)
      }
    },
    {
      dataField: "ZAR",
      text: "ZAR",
      sortable: true,
      onSort: () => handleSort("ZAR"),
      formatter: (cell, row) => {
        const amount = S_FORMAT_CURRENCY_AND_AMOUNT("ZAR", row.ZAR)
        return (amount)
      }
    },

  ];
  /* HANDLES */
  const handleSearch = () => {
    const newParams = {
      year: selectedYear ? selectedYear.value : "",
      month: selectedMonth ? selectedMonth.value : "",
    };
    setSearchParams(newParams);

  };

  const handleReset = () => {
    setSelectedMonth("");
    const resetParams = {
      year: CURRENT_FINANCIAL_YEAR,
      month: "",
    };
    setSearchParams(resetParams);
    setCurrentPage(1);

  };
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
  };

  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(order);
  };


  const handlePageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.EXPORT_EXCHANGE_RATE, {

        year: searchParams.year,
        month: searchParams?.month || "",
        page: currentPage,
        per_page: recordsPerPage,
        sort_by: sortColumn,
        sort_order: sortOrder
      },
        { responseType: 'blob' } // IMPORTANT: this tells axios to handle file as binary
      );

      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'exchange_rates.xlsx'); // custom file name
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  const groupByMonthWithAverages = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const date = new Date(item.fetched_date);
      const monthYear = date.toLocaleString('default', { month: 'short', year: 'numeric' });

      if (!grouped[monthYear]) {
        grouped[monthYear] = { days: [], sums: {}, counts: {}, averages: {} };
      }

      grouped[monthYear].days.push({ ...item, date: date.toISOString().split('T')[0] });

      Object.keys(item).forEach((key) => {
        if (["sr", "fetched_date"].includes(key)) return;

        const val = parseFloat(item[key]);
        if (!isNaN(val)) {
          grouped[monthYear].sums[key] = (grouped[monthYear].sums[key] || 0) + val;
          grouped[monthYear].counts[key] = (grouped[monthYear].counts[key] || 0) + 1;
        }
      });
    });

    // Compute averages
    for (const month in grouped) {
      const { sums, counts } = grouped[month];
      const averages = {};
      for (const currency in sums) {
        averages[currency] = (sums[currency] / counts[currency]).toFixed(2);
      }
      grouped[month].averages = averages;
    }

    return grouped;
  };
  const groupedData = useMemo(() => groupByMonthWithAverages(data), [data]);
  const firstMonthKey = Object.keys(groupedData)[0] || null;
  const [openMonths, setOpenMonths] = useState(firstMonthKey ? { [firstMonthKey]: true } : {});

  const allCurrencies = ['USD', 'EUR', 'GBP', 'SGD', 'ZAR'];
  const toggleMonth = (month) => {
    setOpenMonths((prev) => ({ ...prev, [month]: !prev[month] }));
  };
  const getCurrentMonthKey = () => {
    const today = new Date();
    return today.toLocaleString('default', { month: 'short', year: 'numeric' });
  };
  useEffect(() => {
    const firstKey = Object.keys(groupedData)[0];
    if (firstKey) {
      setOpenMonths({ [firstKey]: true });
    }
  }, [groupedData]);
  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <div className="container-fluid p-0">
        <div className="row mb-5">
          <Col xs={12} sm={9} md={9} lg={10}  >
            <h1 className="h3 mb-2">Exchange <strong>Rates</strong></h1>
          </Col>


        </div>
        <div className="row mb-4">
          <div className="col-12 d-flex justify-content-end">
            <Row className="  justify-content-end w-100">
              <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
                <Select
                  options={financialYears}
                  placeholder="Financial Year..."
                  onChange={handleYearChange}
                  value={selectedYear}
                />
              </Col>
              <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
                <Select
                  options={SD_FY_MONTHS}
                  placeholder="Select Month"
                  onChange={handleMonthChange}
                  value={selectedMonth}
                />
              </Col>
              <Col className="text-right mb-1 mt-2" >
                <Button variant="primary" onClick={handleSearch} >
                  <i className="bx bx-search-alt"></i> Search
                </Button>
                <Button variant="secondary" className='ml-1 ' onClick={handleReset}>
                  <i className="bx bx-x"></i> Reset
                </Button>
                <Button variant="success" className='ml-1 ' onClick={handleExport}>
                  <i class='bx bx-down-arrow-circle'></i> {" "} Export
                </Button>
              </Col>

            </Row>
          </div>
        </div>

        <div className="row mb-1">
          <div className="card flex-fill pt-3 pb-2">
            <div className="accordion" id="exchangeAccordion">
              {Object.entries(groupedData).map(([month, details]) => (
                <>
                  <Table striped bordered key={month}>
                    <thead>
                      <tr onClick={() => toggleMonth(month)}
                        style={{ cursor: 'pointer', fontWeight: 'bold' }}
                      >
                        <th style={{ maxWidth: "100px !important;", width: "100px !important;" }}>{month}  <span
                          className={`accordion-arrow ${openMonths[month] ? 'open' : ''}`}
                        >
                          ▼
                        </span>
                        </th>
                        {allCurrencies.map((curr) => (
                          <th key={curr} >
                            {curr}: {details.averages[curr] || '0.00'}
                          </th>
                        ))}
                      </tr>
                    </thead>
                  </Table>
                  {openMonths[month] && (
                    <div className="accordion-inner-wrapper">
                      <Table striped bordered className="accordion-table">
                        <thead >
                          <tr>
                            <th style={{ width: "100px;" }}>Date</th>
                            {allCurrencies.map((currency) => (
                              <th key={currency}>{currency}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {details.days.map((day, i) => (
                            <tr key={i}>
                              <td>{new Date(day.fetched_date).toLocaleDateString('en-GB')}</td>
                              {allCurrencies.map((currency) => (
                                <td key={currency}>{S_FORMAT_CURRENCY_AND_AMOUNT(currency, day[currency] || '-')} </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}

                </>
              ))}
            </div>
            {/*   <Table striped bordered hover>
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.dataField}
                      onClick={() => col.sortable && handleSort(col.dataField)}
                      style={{ cursor: col.sortable ? "pointer" : "default" }}
                    >
                      {col.text}
                      {col.sortable && (sortColumn === col.dataField ? (sortOrder === "asc" ? " ▲" : " ▼") : "")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {
                  data.length > 0 ? (data.map((item, index) => (
                    <tr key={index}>
                      {columns.map((col) => (
                        <td key={col.dataField} >
                          {col.formatter ? col.formatter(item[col.dataField], item) : item[col.dataField]}
                        </td>
                      ))}
                    </tr>
                  ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )
                }

              </tbody>
            </Table> */}
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            Showing total {totalRecords}
            <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select> records
          </div>
          <div className="col-md-8 text-right">
            <Pagination className="text-right">
              {[...Array(Math.ceil(totalRecords / recordsPerPage)).keys()].map((num) => (
                <Pagination.Item key={num + 1} active={num + 1 === currentPage} onClick={() => setCurrentPage(num + 1)}>
                  {num + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>
        </div>

      </div >
    </>
  );
};


